import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './Table.scss';

const Table = ({children, theme, className, ...props}) => {
  const styleClassNames = classnames({
    'table-board': true,
    [`table-board--${theme}`]: !!theme,
    [className]: !!className,
  });
  return (
    <table className={styleClassNames} {...props}>
      {children}
    </table>
  );
};

Table.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['', 'info', 'form']),
};

export default Table;
